import React from 'react';

import styles from '../MobileCard.module.scss';

import { MobileCardData, MobileField } from '../../types';

import { Button, ButtonModifiers, ButtonTheme } from '@components/Button';
import { CommonTestAttributes } from 'chaika-test-attributes';

export function MobileCardButton<D extends MobileCardData>(
    field: MobileField<D>,
    onButtonClick: (e: React.MouseEvent) => void,
): React.ReactElement<any> {
    return (
        <div className={styles.button}>
            <Button
                dataTest={CommonTestAttributes.MobileCardButton}
                theme={ButtonTheme.Secondary}
                modifiers={[ButtonModifiers.WithoutPaddings, ButtonModifiers.InheritWidth]}
                label={field.title}
                onClick={onButtonClick}
            />
        </div>
    );
}
